/* eslint-disable jsx-a11y/no-static-element-interactions */

import PropTypes from 'prop-types';

import React from 'react';
import classNames from 'classnames';
import Icon from 'react-fa';
import JobTaskConfigEditor from './JobTaskConfigEditor.react';
import JobTaskSpec from '../../stores/specs/JobTaskSpec';

// Not using actual panel components here because they don't
// offer fine-grained enough control -- header takes a string,
// but we need icon components in it. Might be a nice enhancement.

const chevronType = (active) => {
  if (active) {
    return 'chevron-up';
  }
  return 'chevron-down';
};

const JobTask = ({ task, active, taskIndex, updateTask, setActiveTask, removeTask, readOnly }) => (
  <div className='panel panel-default'>
    <div className='panel-heading' onClick={() => setActiveTask(taskIndex)} role='button'>
      <h4 className='panel-title'>
        {task.label}
        <Icon size='lg' name={chevronType(active)} className='pull-right blue-text' />
      </h4>
    </div>
    <div className={classNames('panel-body', { hide: !active })}>
      <JobTaskConfigEditor
        task={task}
        taskIndex={taskIndex}
        updateTask={updateTask}
        removeTask={() => removeTask(taskIndex)}
        readOnly={readOnly}
      />
    </div>
  </div>
);

export default JobTask;

JobTask.propTypes = {
  task: PropTypes.instanceOf(JobTaskSpec),
  taskIndex: PropTypes.number,
  active: PropTypes.bool,
  updateTask: PropTypes.func,
  setActiveTask: PropTypes.func,
  removeTask: PropTypes.func,
  readOnly: PropTypes.bool,
};
